module.exports = __webpack_public_path__ + "static/media/instagram.b156652b.png";